export enum HeaderTypeEnum {
  Default = 'default',
  Book = 'book',
  Course = 'course',
}
